// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, maybe, enumOf } from "@altostra/type-validations";
import { string, unknown, number } from "@altostra/type-validations/lib/primitives";

const isConjunctionFilterKey = enumOf("and_filter", "or_filter");

export const isMessagePrioritizationRulesDataResult = objectOf({
  id: maybe(string, true),
  unreadChangelogCount: maybe(number, true),
  rules: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: maybe(string, true),
      campaigns: arrayOf(
        objectOf({
          id: string,
          name: string,
        })
      ),
      canvases: arrayOf(
        objectOf({
          id: string,
          name: string,
        })
      ),
      campaign_filters: objectOf({
        filter_key: isConjunctionFilterKey,
        filters: arrayOf(
          objectOf({
            filter_key: isConjunctionFilterKey,
            filters: arrayOf(
              objectOf({
                filter_key: string,
                display_name: string,
                comparison_key: string,
                value: maybe(unknown, true),
              })
            ),
          })
        ),
      }),
    })
  ),
});
